import { render, staticRenderFns } from "./MenuLuuma.vue?vue&type=template&id=8db50cb8"
import script from "./MenuLuuma.vue?vue&type=script&lang=js"
export * from "./MenuLuuma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports